import sortBy from 'lodash/sortBy';
import Chatting from '@/services/book/training-states/chatting';
import { ExerciseConverted } from '@/interfaces/class/exercises';
import { Training } from '@/interfaces/class/training';

const allowedTrainings : {
  [key: string]: undefined | Function;
} = {
  Chatting,
  ChattingIntro: undefined,
};

const getState = (exercise: ExerciseConverted) => {
  const updatedData : Training[] = [];

  sortBy(exercise.data, (el: {
    priority: number;
  }) => el.priority).forEach((el: Training) => {
    const trainingConverter = allowedTrainings[el.allowedTrainingTypes[0]];

    if (trainingConverter) {
      updatedData.push(trainingConverter(el));
    } else {
      updatedData.push(el);
    }
  });

  return {
    ...exercise,
    dataTraining: updatedData,
  };
};

export default getState;
